<div class="execution-overview-container">

  <!-- ── OVERVIEW VIEW ─────────────────────────────────────────────── -->
  <ng-container *ngIf="activeView === 'overview'">

    <!-- Top Row: Summary (left placeholder) + Latest Execution (right) -->
    <div class="overview-top-row">

      <!-- Left: Overall Test Result Summary -->
      <div class="summary-placeholder h-100">
        <app-result-summary
          [executionCycles]="executionCycles"
          [summary]="executionSummary"
          [isLoading]="isLoading">
        </app-result-summary>
      </div>

      <!-- Right: Latest Execution View -->
      <div class="latest-execution-panel">
        <app-latest-execution-view
          [isLoading]="isLoading"
          [cycle]="latestCycle!"
          [badge]="latestCycle?.name">
        </app-latest-execution-view>
      </div>

    </div>

    <!-- Bottom: Execution Cycles List -->
    <app-execution-cycle-view
      [isLoading]="isCyclesLoading"
      [executionCycles]="executionCycles"
      [showPagination]="true"
      [serverSidePagination]="true"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      (deleteSelected)="handleDeleteSelected($event)"
      (refresh)="handleRefresh()"
      (filterClick)="handleFilter()"
      (viewDetails)="handleViewDetails($event)"
      (pageChange)="handlePageChange($event)">
    </app-execution-cycle-view>

  </ng-container>

  <!-- ── DETAIL VIEW ───────────────────────────────────────────────── -->
  <ng-container *ngIf="activeView === 'detail'">
    <app-execution-cycle-detail
      *ngIf="selectedCycle"
      [cycle]="selectedCycle"
      [projectId]="projectId"
      [automationProjectId]="automationProjectId">
    </app-execution-cycle-detail>
  </ng-container>

</div>
